import { userApi, memberApi } from '../api';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { memberCustomAttributeDefinitionsQueryKey, profileQueryKey } from '../api/query';
import { sortMembers } from '../utils/MemberUtils';
import { Profile, UpdateMemberRequest, Member } from '@quick/client';

const STALE_TIME = 1000 * 30;

export const useProfileQuery = (refetchInterval?: number) => {
  return useQuery(profileQueryKey(), async () => userApi.getMyProfile(), {
    select: ({ members, ...rest }) => {
      return {
        ...rest,
        members: sortMembers(members),
      };
    },
    refetchInterval,
    staleTime: STALE_TIME,
  });
};

export const useMemberCustomAttributeDefinitions = (communityId: number) => {
  return useQuery(memberCustomAttributeDefinitionsQueryKey(communityId), async () =>
    memberApi.getMemberCustomAttributeDefinitions({
      communityId,
    })
  );
};

export const useMemberMutation = () => {
  const queryClient = useQueryClient();
  const onSuccess = (member: Member) => {
    queryClient.setQueryData<Profile | undefined>(profileQueryKey(), (profile) => {
      if (!profile) {
        return profile;
      }
      const memberToUpdateIndex = profile.members?.findIndex((m) => m.memberId === member.memberId);
      const members = [...(profile.members ?? [])];
      if (memberToUpdateIndex) {
        members[memberToUpdateIndex] = member;
      }
      profile.members = members;
      return profile;
    });
    queryClient.invalidateQueries(profileQueryKey());
  };

  return {
    updateMemberMutation: useMutation((request: UpdateMemberRequest) => memberApi.updateMember(request), {
      onSuccess,
    }),
  };
};
